import styled, {createGlobalStyle, css, keyframes} from 'styled-components'
import {
  fontSmall,
  fontXSmall,
  inputHoverColors
} from '../../../views/action-flow/components/library/css'

const aiTwinkle = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.65; }
`

export const Label = styled.div`
  color: ${({theme}) => theme.colors.grey11};
  pointer-events: none;
  padding-left: 12px;
`

export const RightIconWrapper = styled.div`
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 19px;
  svg {
    max-width: 16px;
  }
`

// Use this if you need to display an icon that triggers the underlying input
// usefull for select boxes etc
export const RightIconClickThroughWrapper = styled(RightIconWrapper)`
  cursor: pointer;
  padding: 7px;
  right: 12px;
  margin-right: 0;
  // this causes the underlying input to be clickable
  pointer-events: none;
  position: absolute;
`

export const AddVariableWrapper = styled.div`
  padding-top: 4px;
  padding-right: 12px;
  /* opacity: 0; // Historically hidden until element is hovered, showing always now */
  flex-shrink: 0;
`

// NOTE these dimensions need to match the hardcoded extra top padding on the
// .editable element
export const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  ${fontSmall}
  &:hover ${AddVariableWrapper}, &:focus-within ${AddVariableWrapper} {
    opacity: 1;
  }
  ${Label} {
    top: 9px;
    position: absolute;
    transition:
      0.1s top,
      0.1s font-size;
  }

  &.labelUp {
    ${Label} {
      top: -1px;
      ${fontXSmall}
    }
    select,
    input[type='datetime-local'],
    input[type='date'] {
      // show these once they have a value ( otherwise label sits over top of the browsers placeholder )
      opacity: 1;
    }
  }
  ${AddVariableWrapper} svg {
    max-width: 16px;
  }
`

export const variableStyle = css<{readOnly?: boolean}>`
  .variable::before {
    background-repeat: no-repeat;
    background-position: center;
    background-image: ${({readOnly}) =>
      `url('data:image/svg+xml,${encodeURIComponent(
        // copy svg from icon/variable-small.svg otherwise we can't adjust current color
        `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Icon" fill="${
            readOnly ? '#000' : '#0081F1'
          }" fill-rule="evenodd" clip-rule="evenodd" d="M1 1C0.447715 1 0 1.44772 0 2V10C0 10.5523 0.447715 11 1 11H2.5C2.77614 11 3 10.7761 3 10.5C3 10.2239 2.77614 10 2.5 10H1V2H2.5C2.77614 2 3 1.77614 3 1.5C3 1.22386 2.77614 1 2.5 1H1ZM7.7831 3C7.43183 3 7.10633 3.1843 6.9256 3.4855L6 5.02817L5.0744 3.4855C4.89367 3.1843 4.56817 3 4.2169 3H4.2155H4.2141H4.2127H4.2113H4.2099H4.2085H4.2071H4.2057H4.2043H4.2029H4.2015H4.2001H4.1987H4.1973H4.1959H4.1945H4.1931H4.1917H4.1903H4.1889H4.1875H4.1861H4.1847H4.1833H4.1819H4.1805H4.1791H4.1777H4.1763H4.1749H4.1735H4.1721H4.1707H4.1693H4.1679H4.1665H4.1651H4.1637H4.1623H4.1609H4.1595H4.1581H4.1567H4.1553H4.1539H4.1525H4.1511H4.14969H4.14829H4.14689H4.14549H4.14409H4.14269H4.14129H4.13989H4.13849H4.13709H4.13569H4.13429H4.13289H4.13149H4.13009H4.12869H4.12729H4.12589H4.12449H4.12309H4.12169H4.12029H4.11889H4.11749H4.11609H4.11469H4.11329H4.11189H4.11049H4.10909H4.10769H4.10629H4.10489H4.10349H4.10209H4.10069H4.09929H4.09789H4.09649H4.09509H4.09369H4.09229H4.09089H4.08949H4.08809H4.08669H4.08529H4.08389H4.08249H4.08109H4.07968H4.07828H4.07688H4.07548H4.07408H4.07268H4.07128H4.06988H4.06848H4.06708H4.06568H4.06428H4.06288H4.06148H4.06008H4.05868H4.05728H4.05588H4.05448H4.05308H4.05168H4.05028H4.04888H4.04748H4.04608H4.04468H4.04328H4.04188H4.04048H4.03908H4.03768H4.03628H4.03488H4.03348H4.03208H4.03068H4.02928H4.02788H4.02648H4.02508H4.02368H4.02228H4.02088H4.01948H4.01808H4.01668H4.01528H4.01388H4.01248H4.01107H4.00967H4.00827H4.00687H4.00547H4.00407H4.00267H4.00127H3.99987H3.99847H3.99707H3.99567H3.99427H3.99287H3.99147H3.99007H3.98867H3.98727H3.98587H3.98447H3.98307H3.98167H3.98027H3.97887H3.97747H3.97607H3.97467H3.97327H3.97187H3.97047H3.96907H3.96767H3.96627H3.96487H3.96347H3.96207H3.96067H3.95927H3.95787H3.95647H3.95507H3.95367H3.95227H3.95087H3.94947H3.94807H3.94667H3.94527H3.94386H3.94246H3.94106H3.93966H3.93826H3.93686H3.93546H3.93406H3.93266H3.93126H3.92986H3.92846H3.92706H3.92566H3.92426H3.92286H3.92146H3.92006H3.91866H3.91726H3.91586H3.91446H3.91306H3.91166H3.91026H3.90886H3.90746H3.90606H3.90466H3.90326H3.90186H3.90046H3.89906H3.89766H3.89626H3.89486H3.89346H3.89206H3.89066H3.88926H3.88786H3.88646H3.88506H3.88366H3.88226H3.88086H3.87946H3.87806H3.87666H3.87525H3.87385H3.87245H3.87105H3.86965H3.86825H3.86685H3.86545H3.86405H3.86265H3.86125H3.85985H3.85845H3.85705H3.85565H3.85425H3.85285H3.85145H3.85005H3.84865H3.84725H3.84585H3.84445H3.84305H3.84165H3.84025H3.83885H3.83745H3.83605H3.83465H3.83325H3.83185H3.83045H3.82905H3.82765H3.82625H3.82485H3.82345H3.82205H3.82065H3.81925H3.81785H3.81645H3.81505H3.81365H3.81225H3.81085H3.80945H3.80804H3.80664H3.80524H3.80384H3.80244H3.80104H3.79964H3.79824H3.79684H3.79544H3.79404H3.79264H3.79124H3.78984H3.78844H3.78704H3.78564H3.78424H3.78284H3.78144H3.78004H3.77864H3.77724H3.77584H3.77444H3.77304H3.77164H3.77024H3.76884H3.76744H3.76604H3.76464H3.76324H3.76184H3.76044H3.75904H3.75764H3.75624H3.75484H3.75344H3.75204H3.75064H3.74924H3.74784H3.74644H3.74504H3.74364H3.74224H3.74084H3.73943H3.73803H3.73663H3.73523H3.73383H3.73243H3.73103H3.72963H3.72823H3.72683H3.72543H3.72403H3.72263H3.72123H3.71983H3.71843H3.71703H3.71563H3.71423H3.71283H3.71143H3.71003H3.70863H3.70723H3.70583H3.70443H3.70303H3.70163H3.70023H3.69883H3.69743H3.69603H3.69463H3.69323H3.69183H3.69043H3.68903H3.68763H3.68623H3.68483H3.68343H3.68203H3.68063H3.67923H3.67783H3.67643H3.67503H3.67363H3.67223H3.67083H3.66942H3.66802H3.66662H3.66522H3.66382H3.66242H3.66102H3.65962H3.65822H3.65682H3.65542H3.65402H3.65262H3.65122H3.64982H3.64842H3.64702H3.64562H3.64422H3.64282H3.64142H3.64002H3.63862H3.63722H3.63582H3.63442H3.63302H3.63162H3.63022H3.62882H3.62742H3.62602H3.62462H3.62322H3.62182H3.62042H3.61902H3.61762H3.61622H3.61482H3.61342H3.61202H3.61062H3.60922H3.60782H3.60642H3.60502H3.60362H3.60222H3.60081H3.59941H3.59801H3.59661H3.59521H3.59381H3.59241H3.59101H3.58961H3.58821H3.58681H3.58541H3.58401H3.58261H3.58121H3.57981H3.57841H3.57701H3.57561H3.57421H3.57281H3.57141H3.57001H3.56861H3.56721H3.56581H3.56441H3.56301H3.56161H3.56021H3.55881H3.55741H3.55601H3.55461H3.55321H3.55181H3.55041H3.54901H3.54761H3.54621H3.54481H3.54341H3.54201H3.54061H3.53921H3.53781H3.53641H3.53501H3.5336H3.5322H3.5308H3.5294H3.528H3.5266H3.5252H3.5238H3.5224H3.521H3.5196H3.5182H3.5168H3.5154H3.514H3.5126H3.5112H3.5098H3.5084H3.507H3.5056H3.5042H3.5028H3.5014H3.5C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H3.5014H3.5028H3.5042H3.5056H3.507H3.5084H3.5098H3.5112H3.5126H3.514H3.5154H3.5168H3.5182H3.5196H3.521H3.5224H3.5238H3.5252H3.5266H3.528H3.5294H3.5308H3.5322H3.5336H3.53501H3.53641H3.53781H3.53921H3.54061H3.54201H3.54341H3.54481H3.54621H3.54761H3.54901H3.55041H3.55181H3.55321H3.55461H3.55601H3.55741H3.55881H3.56021H3.56161H3.56301H3.56441H3.56581H3.56721H3.56861H3.57001H3.57141H3.57281H3.57421H3.57561H3.57701H3.57841H3.57981H3.58121H3.58261H3.58401H3.58541H3.58681H3.58821H3.58961H3.59101H3.59241H3.59381H3.59521H3.59661H3.59801H3.59941H3.60081H3.60222H3.60362H3.60502H3.60642H3.60782H3.60922H3.61062H3.61202H3.61342H3.61482H3.61622H3.61762H3.61902H3.62042H3.62182H3.62322H3.62462H3.62602H3.62742H3.62882H3.63022H3.63162H3.63302H3.63442H3.63582H3.63722H3.63862H3.64002H3.64142H3.64282H3.64422H3.64562H3.64702H3.64842H3.64982H3.65122H3.65262H3.65402H3.65542H3.65682H3.65822H3.65962H3.66102H3.66242H3.66382H3.66522H3.66662H3.66802H3.66942H3.67083H3.67223H3.67363H3.67503H3.67643H3.67783H3.67923H3.68063H3.68203H3.68343H3.68483H3.68623H3.68763H3.68903H3.69043H3.69183H3.69323H3.69463H3.69603H3.69743H3.69883H3.70023H3.70163H3.70303H3.70443H3.70583H3.70723H3.70863H3.71003H3.71143H3.71283H3.71423H3.71563H3.71703H3.71843H3.71983H3.72123H3.72263H3.72403H3.72543H3.72683H3.72823H3.72963H3.73103H3.73243H3.73383H3.73523H3.73663H3.73803H3.73943H3.74084H3.74224H3.74364H3.74504H3.74644H3.74784H3.74924H3.75064H3.75204H3.75344H3.75484H3.75624H3.75764H3.75904H3.76044H3.76184H3.76324H3.76464H3.76604H3.76744H3.76884H3.77024H3.77164H3.77304H3.77444H3.77584H3.77724H3.77864H3.78004H3.78144H3.78284H3.78424H3.78564H3.78704H3.78844H3.78984H3.79124H3.79264H3.79404H3.79544H3.79684H3.79824H3.79964H3.80104H3.80244H3.80384H3.80524H3.80664H3.80804H3.80945H3.81085H3.81225H3.81365H3.81505H3.81645H3.81785H3.81925H3.82065H3.82205H3.82345H3.82485H3.82625H3.82765H3.82905H3.83045H3.83185H3.83325H3.83465H3.83605H3.83745H3.83885H3.84025H3.84165H3.84305H3.84445H3.84585H3.84725H3.84865H3.85005H3.85145H3.85285H3.85425H3.85565H3.85705H3.85845H3.85985H3.86125H3.86265H3.86405H3.86545H3.86685H3.86825H3.86965H3.87105H3.87245H3.87385H3.87525H3.87666H3.87806H3.87946H3.88086H3.88226H3.88366H3.88506H3.88646H3.88786H3.88926H3.89066H3.89206H3.89346H3.89486H3.89626H3.89766H3.89906H3.90046H3.90186H3.90326H3.90466H3.90606H3.90746H3.90886H3.91026H3.91166H3.91306H3.91446H3.91586H3.91726H3.91866H3.92006H3.92146H3.92286H3.92426H3.92566H3.92706H3.92846H3.92986H3.93126H3.93266H3.93406H3.93546H3.93686H3.93826H3.93966H3.94106H3.94246H3.94386H3.94527H3.94667H3.94807H3.94947H3.95087H3.95227H3.95367H3.95507H3.95647H3.95787H3.95927H3.96067H3.96207H3.96347H3.96487H3.96627H3.96767H3.96907H3.97047H3.97187H3.97327H3.97467H3.97607H3.97747H3.97887H3.98027H3.98167H3.98307H3.98447H3.98587H3.98727H3.98867H3.99007H3.99147H3.99287H3.99427H3.99567H3.99707H3.99847H3.99987H4.00127H4.00267H4.00407H4.00547H4.00687H4.00827H4.00967H4.01107H4.01248H4.01388H4.01528H4.01668H4.01808H4.01948H4.02088H4.02228H4.02368H4.02508H4.02648H4.02788H4.02928H4.03068H4.03208H4.03348H4.03488H4.03628H4.03768H4.03908H4.04048H4.04188H4.04328H4.04468H4.04608H4.04748H4.04888H4.05028H4.05168H4.05308H4.05448H4.05588H4.05728H4.05868H4.06008H4.06148H4.06288H4.06428H4.06568H4.06708H4.06848H4.06988H4.07128H4.07268H4.07408H4.07548H4.07688H4.07828H4.07968H4.08109H4.08249H4.08389H4.08529H4.08669H4.08809H4.08949H4.09089H4.09229H4.09369H4.09509H4.09649H4.09789H4.09929H4.10069H4.10209H4.10349H4.10489H4.10629H4.10769H4.10909H4.11049H4.11189H4.11329H4.11469H4.11609H4.11749H4.11889H4.12029H4.12169H4.12309H4.12449H4.12589H4.12729H4.12869H4.13009H4.13149H4.13289H4.13429H4.13569H4.13709H4.13849H4.13989H4.14129H4.14269H4.14409H4.14549H4.14689H4.14829H4.14969H4.1511H4.1525H4.1539H4.1553H4.1567H4.1581H4.1595H4.1609H4.1623H4.1637H4.1651H4.1665H4.1679H4.1693H4.1707H4.1721H4.1735H4.1749H4.1763H4.1777H4.1791H4.1805H4.1819H4.1833H4.1847H4.1861H4.1875H4.1889H4.1903H4.1917H4.1931H4.1945H4.1959H4.1973H4.1987H4.2001H4.2015H4.2029H4.2043H4.2057H4.2071H4.2085H4.2099H4.2113H4.2127H4.2141H4.2155H4.2169L5.4169 6L4.2169 8H3V7.5C3 7.22386 2.77614 7 2.5 7C2.22386 7 2 7.22386 2 7.5V8C2 8.55228 2.44772 9 3 9H4.2169C4.56817 9 4.89367 8.8157 5.0744 8.5145L6 6.97183L6.9256 8.5145C7.10644 8.81588 7.43224 9 7.78329 9H7.78472H7.78615H7.78757H7.78899H7.79041H7.79182H7.79323H7.79464H7.79604H7.79744H7.79884H7.80023H7.80162H7.80301H7.80439H7.80577H7.80715H7.80852H7.80989H7.81126H7.81262H7.81398H7.81534H7.8167H7.81805H7.8194H7.82074H7.82209H7.82343H7.82476H7.8261H7.82743H7.82876H7.83008H7.8314H7.83272H7.83404H7.83535H7.83667H7.83797H7.83928H7.84058H7.84188H7.84318H7.84448H7.84577H7.84706H7.84835H7.84963H7.85091H7.85219H7.85347H7.85474H7.85601H7.85728H7.85855H7.85982H7.86108H7.86234H7.8636H7.86485H7.8661H7.86735H7.8686H7.86985H7.87109H7.87233H7.87357H7.87481H7.87605H7.87728H7.87851H7.87974H7.88097H7.88219H7.88341H7.88463H7.88585H7.88707H7.88828H7.8895H7.89071H7.89192H7.89312H7.89433H7.89553H7.89673H7.89793H7.89913H7.90033H7.90152H7.90271H7.9039H7.90509H7.90628H7.90747H7.90865H7.90983H7.91102H7.9122H7.91337H7.91455H7.91572H7.9169H7.91807H7.91924H7.92041H7.92158H7.92275H7.92391H7.92507H7.92624H7.9274H7.92856H7.92972H7.93087H7.93203H7.93319H7.93434H7.93549H7.93664H7.93779H7.93894H7.94009H7.94124H7.94238H7.94353H7.94467H7.94582H7.94696H7.9481H7.94924H7.95038H7.95152H7.95266H7.95379H7.95493H7.95606H7.9572H7.95833H7.95947H7.9606H7.96173H7.96286H7.96399H7.96512H7.96625H7.96738H7.96851H7.96963H7.97076H7.97189H7.97301H7.97414H7.97526H7.97639H7.97751H7.97863H7.97976H7.98088H7.982H7.98312H7.98424H7.98537H7.98649H7.98761H7.98873H7.98985H7.99097H7.99209H7.99321H7.99433H7.99545H7.99657H7.99769H7.99881H7.99993H8.00105H8.00217H8.00329H8.00441H8.00553H8.00665H8.00777H8.00889H8.01001H8.01113H8.01225H8.01337H8.01449H8.01561H8.01673H8.01786H8.01898H8.0201H8.02122H8.02235H8.02347H8.0246H8.02572H8.02684H8.02797H8.0291H8.03022H8.03135H8.03248H8.03361H8.03473H8.03586H8.03699H8.03813H8.03926H8.04039H8.04152H8.04266H8.04379H8.04492H8.04606H8.0472H8.04834H8.04947H8.05061H8.05175H8.05289H8.05404H8.05518H8.05632H8.05747H8.05861H8.05976H8.06091H8.06206H8.06321H8.06436H8.06551H8.06667H8.06782H8.06898H8.07014H8.07129H8.07245H8.07361H8.07478H8.07594H8.0771H8.07827H8.07944H8.08061H8.08178H8.08295H8.08412H8.0853H8.08648H8.08765H8.08883H8.09001H8.0912H8.09238H8.09357H8.09475H8.09594H8.09713H8.09833H8.09952H8.10072H8.10191H8.10311H8.10431H8.10552H8.10672H8.10793H8.10914H8.11035H8.11156H8.11278H8.11399H8.11521H8.11643H8.11765H8.11888H8.1201H8.12133H8.12256H8.1238H8.12503H8.12627H8.12751H8.12875H8.12999H8.13124H8.13248H8.13374H8.13499H8.13624H8.1375H8.13876H8.14002H8.14129H8.14255H8.14382H8.14509H8.14637H8.14764H8.14892H8.15021H8.15149H8.15278H8.15407H8.15536H8.15665H8.15795H8.15925H8.16055H8.16186H8.16317H8.16448H8.16579H8.16711H8.16843H8.16975H8.17107H8.1724H8.17373H8.17507H8.1764H8.17774H8.17908H8.18043H8.18178H8.18313H8.18448H8.18584H8.1872H8.18857H8.18993H8.1913H8.19268H8.19405H8.19543H8.19682H8.1982H8.19959H8.20098H8.20238H8.20378H8.20518H8.20659H8.208H8.20941H8.21083H8.21225H8.21367H8.2151H8.21653H8.21796H8.2194H8.22084H8.22228H8.22373H8.22519H8.22664H8.2281H8.22956H8.23103H8.2325H8.23397H8.23545H8.23693H8.23842H8.23991H8.2414H8.2429H8.2444H8.2459H8.24741H8.24892H8.25044H8.25196H8.25349H8.25501H8.25655H8.25808H8.25962H8.26117H8.26272H8.26427H8.26583H8.26739H8.26896H8.27053H8.2721H8.27368H8.27526H8.27685H8.27844H8.28004H8.28164H8.28324H8.28485H8.28646H8.28808H8.2897H8.29133H8.29296H8.2946H8.29624H8.29788H8.29953H8.30119H8.30285H8.30451H8.30618H8.30785H8.30953H8.31121H8.3129H8.31459H8.31629H8.31799H8.31969H8.3214H8.32312H8.32484H8.32657H8.3283H8.33003H8.33177H8.33352H8.33527H8.33702H8.33879H8.34055H8.34232H8.3441H8.34588H8.34767H8.34946H8.35125H8.35306H8.35486H8.35667H8.35849H8.36032H8.36214H8.36398H8.36582H8.36766H8.36951H8.37136H8.37322H8.37509H8.37696H8.37884H8.38072H8.38261H8.3845H8.3864H8.38831H8.39021H8.39213H8.39405H8.39598H8.39791H8.39985H8.40179H8.40374H8.4057H8.40766H8.40963H8.4116H8.41358H8.41557H8.41756H8.41955H8.42156H8.42356H8.42558H8.4276H8.42963H8.43166H8.4337H8.43574H8.43779H8.43985H8.44191H8.44398H8.44606H8.44814H8.45023H8.45232H8.45442H8.45653H8.45864H8.46076H8.46288H8.46501H8.46715H8.4693H8.47145H8.4736H8.47577H8.47794H8.48012H8.4823H8.48449H8.48668H8.48889H8.4911H8.49331H8.49553H8.49776H8.5C8.77614 9 9 8.77614 9 8.5C9 8.22386 8.77614 8 8.5 8H8.49776H8.49553H8.49331H8.4911H8.48889H8.48668H8.48449H8.4823H8.48012H8.47794H8.47577H8.4736H8.47145H8.4693H8.46715H8.46501H8.46288H8.46076H8.45864H8.45653H8.45442H8.45232H8.45023H8.44814H8.44606H8.44398H8.44191H8.43985H8.43779H8.43574H8.4337H8.43166H8.42963H8.4276H8.42558H8.42356H8.42156H8.41955H8.41756H8.41557H8.41358H8.4116H8.40963H8.40766H8.4057H8.40374H8.40179H8.39985H8.39791H8.39598H8.39405H8.39213H8.39021H8.38831H8.3864H8.3845H8.38261H8.38072H8.37884H8.37696H8.37509H8.37322H8.37136H8.36951H8.36766H8.36582H8.36398H8.36214H8.36032H8.35849H8.35667H8.35486H8.35306H8.35125H8.34946H8.34767H8.34588H8.3441H8.34232H8.34055H8.33879H8.33702H8.33527H8.33352H8.33177H8.33003H8.3283H8.32657H8.32484H8.32312H8.3214H8.31969H8.31799H8.31629H8.31459H8.3129H8.31121H8.30953H8.30785H8.30618H8.30451H8.30285H8.30119H8.29953H8.29788H8.29624H8.2946H8.29296H8.29133H8.2897H8.28808H8.28646H8.28485H8.28324H8.28164H8.28004H8.27844H8.27685H8.27526H8.27368H8.2721H8.27053H8.26896H8.26739H8.26583H8.26427H8.26272H8.26117H8.25962H8.25808H8.25655H8.25501H8.25349H8.25196H8.25044H8.24892H8.24741H8.2459H8.2444H8.2429H8.2414H8.23991H8.23842H8.23693H8.23545H8.23397H8.2325H8.23103H8.22956H8.2281H8.22664H8.22519H8.22373H8.22228H8.22084H8.2194H8.21796H8.21653H8.2151H8.21367H8.21225H8.21083H8.20941H8.208H8.20659H8.20518H8.20378H8.20238H8.20098H8.19959H8.1982H8.19682H8.19543H8.19405H8.19268H8.1913H8.18993H8.18857H8.1872H8.18584H8.18448H8.18313H8.18178H8.18043H8.17908H8.17774H8.1764H8.17507H8.17373H8.1724H8.17107H8.16975H8.16843H8.16711H8.16579H8.16448H8.16317H8.16186H8.16055H8.15925H8.15795H8.15665H8.15536H8.15407H8.15278H8.15149H8.15021H8.14892H8.14764H8.14637H8.14509H8.14382H8.14255H8.14129H8.14002H8.13876H8.1375H8.13624H8.13499H8.13374H8.13248H8.13124H8.12999H8.12875H8.12751H8.12627H8.12503H8.1238H8.12256H8.12133H8.1201H8.11888H8.11765H8.11643H8.11521H8.11399H8.11278H8.11156H8.11035H8.10914H8.10793H8.10672H8.10552H8.10431H8.10311H8.10191H8.10072H8.09952H8.09833H8.09713H8.09594H8.09475H8.09357H8.09238H8.0912H8.09001H8.08883H8.08765H8.08648H8.0853H8.08412H8.08295H8.08178H8.08061H8.07944H8.07827H8.0771H8.07594H8.07478H8.07361H8.07245H8.07129H8.07014H8.06898H8.06782H8.06667H8.06551H8.06436H8.06321H8.06206H8.06091H8.05976H8.05861H8.05747H8.05632H8.05518H8.05404H8.05289H8.05175H8.05061H8.04947H8.04834H8.0472H8.04606H8.04492H8.04379H8.04266H8.04152H8.04039H8.03926H8.03813H8.03699H8.03586H8.03473H8.03361H8.03248H8.03135H8.03022H8.0291H8.02797H8.02684H8.02572H8.0246H8.02347H8.02235H8.02122H8.0201H8.01898H8.01786H8.01673H8.01561H8.01449H8.01337H8.01225H8.01113H8.01001H8.00889H8.00777H8.00665H8.00553H8.00441H8.00329H8.00217H8.00105H7.99993H7.99881H7.99769H7.99657H7.99545H7.99433H7.99321H7.99209H7.99097H7.98985H7.98873H7.98761H7.98649H7.98537H7.98424H7.98312H7.982H7.98088H7.97976H7.97863H7.97751H7.97639H7.97526H7.97414H7.97301H7.97189H7.97076H7.96963H7.96851H7.96738H7.96625H7.96512H7.96399H7.96286H7.96173H7.9606H7.95947H7.95833H7.9572H7.95606H7.95493H7.95379H7.95266H7.95152H7.95038H7.94924H7.9481H7.94696H7.94582H7.94467H7.94353H7.94238H7.94124H7.94009H7.93894H7.93779H7.93664H7.93549H7.93434H7.93319H7.93203H7.93087H7.92972H7.92856H7.9274H7.92624H7.92507H7.92391H7.92275H7.92158H7.92041H7.91924H7.91807H7.9169H7.91572H7.91455H7.91337H7.9122H7.91102H7.90983H7.90865H7.90747H7.90628H7.90509H7.9039H7.90271H7.90152H7.90033H7.89913H7.89793H7.89673H7.89553H7.89433H7.89312H7.89192H7.89071H7.8895H7.88828H7.88707H7.88585H7.88463H7.88341H7.88219H7.88097H7.87974H7.87851H7.87728H7.87605H7.87481H7.87357H7.87233H7.87109H7.86985H7.8686H7.86735H7.8661H7.86485H7.8636H7.86234H7.86108H7.85982H7.85855H7.85728H7.85601H7.85474H7.85347H7.85219H7.85091H7.84963H7.84835H7.84706H7.84577H7.84448H7.84318H7.84188H7.84058H7.83928H7.83797H7.83667H7.83535H7.83404H7.83272H7.8314H7.83008H7.82876H7.82743H7.8261H7.82476H7.82343H7.82209H7.82074H7.8194H7.81805H7.8167H7.81534H7.81398H7.81262H7.81126H7.80989H7.80852H7.80715H7.80577H7.80439H7.80301H7.80162H7.80023H7.79884H7.79744H7.79604H7.79464H7.79323H7.79182H7.79041H7.78899H7.78757H7.78615H7.78472H7.78329L7.78309 8L6.5831 6L7.78309 4L9 4V4.5C9 4.77614 9.22386 5 9.5 5C9.77614 5 10 4.77614 10 4.5V4C10 3.44772 9.55228 3 9 3H7.7831ZM12 2C12 1.44772 11.5523 1 11 1H9.5C9.22386 1 9 1.22386 9 1.5C9 1.77614 9.22386 2 9.5 2H11V10H9.5C9.22386 10 9 10.2239 9 10.5C9 10.7761 9.22386 11 9.5 11H11C11.5523 11 12 10.5523 12 10V2Z" />
          </svg>
          `
      )}')`};
    margin-right: 4px;
    background-size: 12px 12px;
    padding-right: 16px;
    content: '';
    display: inline;
    white-space: nowrap;
  }
  .variable.profile::before {
    background-image: ${({readOnly}) =>
      `url('data:image/svg+xml,${encodeURIComponent(
        // copy svg from icon/profile-small.svg otherwise we can't adjust current color
        `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Icon" fill="${
            readOnly ? '#000' : '#617D0D'
          }" fill-rule="evenodd" clip-rule="evenodd" d="M9.5991 9.47081C10.4665 8.57156 11 7.34808 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 7.34807 1.53349 8.57153 2.40087 9.47078C3.36985 8.63258 4.62632 8.12499 5.99997 8.12499C7.37364 8.12499 8.63012 8.63259 9.5991 9.47081ZM8.82446 10.1264C8.04641 9.49822 7.06541 9.12499 5.99997 9.12499C4.93454 9.12499 3.95355 9.49821 3.1755 10.1264C3.97915 10.6775 4.95191 11 6 11C7.04807 11 8.02083 10.6775 8.82446 10.1264ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM8.46936 5.2653C8.46936 6.6291 7.36378 7.73469 5.99997 7.73469C4.63616 7.73469 3.53058 6.6291 3.53058 5.2653C3.53058 3.90149 4.63616 2.79591 5.99997 2.79591C7.36378 2.79591 8.46936 3.90149 8.46936 5.2653ZM5.99997 6.73469C6.81149 6.73469 7.46936 6.07682 7.46936 5.2653C7.46936 4.45378 6.81149 3.79591 5.99997 3.79591C5.18845 3.79591 4.53058 4.45378 4.53058 5.2653C4.53058 6.07682 5.18845 6.73469 5.99997 6.73469Z" />
          </svg>`
      )}')`};
  }
  .variable.context::before {
    background-image: ${({readOnly}) =>
      `url('data:image/svg+xml,${encodeURIComponent(
        // copy svg from icon/context-output-small.svg otherwise we can't adjust current color
        `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Icon" fill="${
            readOnly ? '#000' : '#A43CB4'
          }" fill-rule="evenodd" clip-rule="evenodd" d="M0 2C0 1.44772 0.447715 1 1 1H11C11.5523 1 12 1.44772 12 2V8C12 8.55228 11.5523 9 11 9H9.5C9.22386 9 9 8.77614 9 8.5C9 8.22386 9.22386 8 9.5 8H11V2L1 2V8H3.5C3.77614 8 4 8.22386 4 8.5C4 8.77614 3.77614 9 3.5 9H1C0.447715 9 0 8.55228 0 8V2ZM3 4.5C3 4.77614 3.22386 5 3.5 5H6L6 10.5657L5.27735 10.084C5.04759 9.9308 4.73715 9.99289 4.58397 10.2227C4.4308 10.4524 4.49289 10.7628 4.72265 10.916L6.22265 11.916C6.3906 12.028 6.6094 12.028 6.77735 11.916L8.27735 10.916C8.50711 10.7628 8.5692 10.4524 8.41603 10.2226C8.26285 9.99289 7.95241 9.9308 7.72265 10.084L7 10.5657L7 5C7 4.44772 6.55228 4 6 4L3.5 4C3.22386 4 3 4.22386 3 4.5Z"/>
          </svg>`
      )}')`};
  }
  .variable.file-upload::before {
    background-image: ${({readOnly}) =>
      `url('data:image/svg+xml,${encodeURIComponent(
        // copy svg from icon/media-alt-small.svg otherwise we can't adjust current color
        `<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Icon" fill="${
            readOnly ? '#000' : '#A43CB4'
          }" fill-rule="evenodd" clip-rule="evenodd" d="M4 1H15V8.83417L12.5236 7.24217C12.212 7.0419 11.8153 7.0302 11.4925 7.21177L4 11.4263V1ZM11.9828 8.08335L15 10.023V12H5.01986L11.9828 8.08335ZM3 1C3 0.447715 3.44772 0 4 0H15C15.5523 0 16 0.447715 16 1V12C16 12.5523 15.5523 13 15 13H4C3.44772 13 3 12.5523 3 12V1ZM1 6.5C1 6.22386 0.776142 6 0.5 6C0.223858 6 0 6.22386 0 6.5V14.5C0 15.3284 0.671573 16 1.5 16H9.5C9.77614 16 10 15.7761 10 15.5C10 15.2239 9.77614 15 9.5 15H1.5C1.22386 15 1 14.7761 1 14.5V6.5ZM8 3C6.89543 3 6 3.89543 6 5C6 6.10457 6.89543 7 8 7C9.10457 7 10 6.10457 10 5C10 3.89543 9.10457 3 8 3ZM7 5C7 4.44771 7.44771 4 8 4C8.55229 4 9 4.44771 9 5C9 5.55229 8.55229 6 8 6C7.44771 6 7 5.55229 7 5Z"/>
          </svg>`
      )}')`};
  }
  .variable.multi-instance::before {
    background-image: ${({readOnly}) =>
      `url('data:image/svg+xml,${encodeURIComponent(
        // copy svg from icon/copy-small.svg otherwise we can't adjust current color
        `<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Icon" fill="${
            readOnly ? '#000' : '#617D0D'
          }" fill-rule="evenodd" clip-rule="evenodd" d="M14 11H5V2H14V11ZM4 1.5C4 1.22386 4.22386 1 4.5 1H14.5C14.7761 1 15 1.22386 15 1.5V11.5C15 11.7761 14.7761 12 14.5 12H4.5C4.22386 12 4 11.7761 4 11.5V1.5ZM2 6.5C2 6.22386 1.77614 6 1.5 6C1.22386 6 1 6.22386 1 6.5V14C1 14.5523 1.44772 15 2 15H9.5C9.77614 15 10 14.7761 10 14.5C10 14.2239 9.77614 14 9.5 14H2V6.5Z"/>
          </svg>`
      )}')`};
  }
  .variable.card-instance::before {
    background-image: ${({readOnly}) =>
      `url('data:image/svg+xml,${encodeURIComponent(
        // copy svg from icon/card-simple-small.svg otherwise we can't adjust current color
        `<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Icon" fill="${
            readOnly ? '#000' : '#0081F1'
          }" fill-rule="evenodd" clip-rule="evenodd" d="M3 1C2.44771 1 2 1.44772 2 2V14C2 14.5523 2.44771 15 3 15H13.0769C13.6292 15 14.0769 14.5523 14.0769 14V10.5C14.0769 10.2239 13.8531 10 13.5769 10C13.3008 10 13.0769 10.2239 13.0769 10.5V14H3V2L11.5769 2C11.8531 2 12.0769 1.77614 12.0769 1.5C12.0769 1.22386 11.8531 1 11.5769 1H3ZM14.8674 3.83914C15.0547 3.63623 15.0421 3.3199 14.8391 3.1326C14.6362 2.9453 14.3199 2.95795 14.1326 3.16086L8.48557 9.27847L5.85355 6.64645C5.65829 6.45118 5.34171 6.45118 5.14645 6.64645C4.95118 6.84171 4.95118 7.15829 5.14645 7.35355L8.14645 10.3536C8.24267 10.4498 8.37395 10.5026 8.50999 10.4999C8.64604 10.4972 8.7751 10.4391 8.8674 10.3391L14.8674 3.83914Z"/>
          </svg>`
      )}')`};
  }
  .variable.flow-instance::before {
    background-image: ${({readOnly}) =>
      `url('data:image/svg+xml,${encodeURIComponent(
        // copy svg from icon/action-flow-small.svg otherwise we can't adjust current color
        `<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Icon" fill="${
            readOnly ? '#000' : '#0081F1'
          }" fill-rule="evenodd" clip-rule="evenodd" d="M9 3C9 3.55228 8.55228 4 8 4C7.44772 4 7 3.55228 7 3C7 2.44772 7.44772 2 8 2C8.55228 2 9 2.44772 9 3ZM8.50019 4.93694C9.36271 4.71485 10 3.93185 10 3C10 1.89543 9.10457 1 8 1C6.89543 1 6 1.89543 6 3C6 3.93199 6.63748 4.71509 7.50019 4.93704V5.3896C7.50019 6.42837 7.93685 7.41929 8.70347 8.12024L10.1219 9.41719C10.6814 9.92869 11 10.6518 11 11.4098V13.2929L9.85355 12.1464C9.65829 11.9512 9.34171 11.9512 9.14645 12.1464C8.95118 12.3417 8.95118 12.6583 9.14645 12.8536L11.1464 14.8536C11.3417 15.0488 11.6583 15.0488 11.8536 14.8536L13.8536 12.8536C14.0488 12.6583 14.0488 12.3417 13.8536 12.1464C13.6583 11.9512 13.3417 11.9512 13.1464 12.1464L12 13.2929V11.4098C12 10.371 11.5633 9.38013 10.7967 8.67918L9.37826 7.38223C8.81884 6.87072 8.50019 6.14762 8.50019 5.3896V4.93694ZM6.79996 8.90003C7.02089 8.73436 7.06569 8.42097 6.90003 8.20004C6.73436 7.97911 6.42097 7.93431 6.20004 8.09997L5.48028 8.63969C4.54843 9.33843 4 10.4352 4 11.5999V13.2929L2.85355 12.1464C2.65829 11.9512 2.34171 11.9512 2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536L4.14645 14.8536C4.34171 15.0488 4.65829 15.0488 4.85355 14.8536L6.85355 12.8536C7.04882 12.6583 7.04882 12.3417 6.85355 12.1464C6.65829 11.9512 6.34171 11.9512 6.14645 12.1464L5 13.2929V11.5999C5 10.75 5.40021 9.94964 6.0802 9.43974L6.79996 8.90003Z"/>
        </svg>`
      )}')`};
  }
  .variable.subview::before {
    background-image: ${({readOnly}) =>
      `url('data:image/svg+xml,${encodeURIComponent(
        // copy svg from icon/subview-small.svg otherwise we can't adjust current color
        `<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="Icon" fill="${
            readOnly ? '#000' : '#C75300'
          }" fill-rule="evenodd" clip-rule="evenodd" d="M3 2H13L13 4H3L3 2ZM3 5L3 14L13 14V5H3ZM2 2C2 1.44772 2.44772 1 3 1H13C13.5523 1 14 1.44772 14 2V14C14 14.5523 13.5523 15 13 15H3C2.44772 15 2 14.5523 2 14V2Z"/>
          </svg>`
      )}')`};
  }
  .variable.error::before {
    background-image: ${({readOnly}) =>
      `url('data:image/svg+xml,${encodeURIComponent(
        // copy svg from icon/icon-warning-small.svg otherwise we can't adjust current color
        `<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="${
            readOnly ? '#000' : '#C75300'
          }" fill-rule="evenodd" clip-rule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12ZM9 4C9 3.44772 8.55228 3 8 3C7.44772 3 7 3.44772 7 4V9C7 9.55228 7.44772 10 8 10C8.55228 10 9 9.55228 9 9V4Z"/>
          </svg>`
      )}')`};
  }
  .variable.ai-context::before {
    background-image: ${({readOnly, theme}) =>
      `url('data:image/svg+xml,${encodeURIComponent(
        `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="${
            readOnly ? '#000' : `rgb(${theme.aiToRgb})`
          }" d="M6 0C6.45 3.15 8.4 5.1 11.55 5.55C8.4 6 6.45 7.95 6 11.1C5.55 7.95 3.6 6 0.45 5.55C3.6 5.1 5.55 3.15 6 0Z"/>
        </svg>`
      )}')`};
    ${({readOnly}) =>
      readOnly
        ? ''
        : css`
            animation: ${aiTwinkle} 1.8s ease-in-out infinite;
          `}
  }
  .variable {
    display: inline-block;
    text-align: center;
    ${fontXSmall}
    font-family: 'atomic___RobotoMono', monospace;
    border-radius: 12px;
    border: solid 1px ${({theme}) => theme.colors.grey3};
    padding: 0px 7px;
    height: 18px;
    user-select: none;
    white-space: nowrap;
    color: ${({theme}) => theme.colors.grey12};
    ${({readOnly, theme}) =>
      readOnly
        ? css`
            background: ${theme.colors.grey4};
          `
        : css`
            background: ${theme.colors.blue5};
            cursor: pointer;
            &.multi-instance,
            &.profile {
              background: ${theme.colors.lime5};
            }
            &.file-upload,
            &.context {
              background: ${theme.colors.plum5};
            }
            &.ai-context {
              background: linear-gradient(
                90deg,
                rgba(${theme.aiFromRgb}, 0.16),
                rgba(${theme.aiToRgb}, 0.16)
              );
              border-color: rgba(${theme.aiToRgb}, 0.35);
            }
            &.subview,
            &.error {
              background: ${theme.colors.orange5};
            }
            &.invalid {
              background: ${theme.colors.orange3};
            }
            /*
              Removing until we have hover colors for other variable types
              &:hover,
              &:focus {
                color: ${theme.colors.blue13};
                background: ${theme.colors.blue6};
              }
              &:active {
                background: ${theme.colors.blue7};
              } */
          `}
    &.invalid {
      text-decoration: line-through;
    }
  }
`

export const StyledTextEditor = styled.div<{readOnly?: boolean}>`
  flex: 1;
  ${
    ({readOnly}) =>
      readOnly
        ? css`
            width: 100%;
          `
        : css`
            width: calc(100% - 32px);
          `
    // 32 here leaves room for the add variable icon, this seems to only be required for chrome not FF oddly
  };

  ${fontSmall}
  &:has(input) {
    // hacking around a visual difference between FF and chrome here
    // chromes getting a value of 37.5 for inputs vs a 34 for other elements despite identical styles
    // might need to revisit this, but its all I could come up with after spending a while on it
    block-size: 34px;

    .compact & {
      block-size: 20px;
    }
  }
  > input[type='number'] {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
  }
  > input[type='number']::-webkit-inner-spin-button,
  > input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
  > input[type='datetime-local'] {
    padding-right: 16px; // space the calender icon the browser gives us
    opacity: 0; // hide placeholder date, we'll show it when we have a value in Wrapper
  }
  > input[type='date'] {
    opacity: 0; // hide placeholder date, we'll show it when we have a value in Wrapper
  }

  > input {
    text-align: left;
  }
  > select {
    -webkit-appearance: none;
    -moz-appearance: none;
    // hide browser styles for select, safari makes a mess otherwise
    opacity: 0; // we will show when we value via in Wrapper above
  }

  > select:focus,
  input:focus {
    outline: none;
  }
  > select,
  > textarea,
  > input,
  .script-editor,
  .editable {
    width: 100%;
    ${fontSmall}
    flex: 1;
    padding: 0px;
    margin: 0px;
    padding-left: 12px;
    padding-top: 16px;

    min-height: 18px;
    min-width: 100%;
    line-height: 18px;
    border: none;
    background-color: transparent;
    color: inherit;
    overflow-wrap: anywhere; // create a break when an entire word cannot be placed on its own line without overflowing.
    // this ensures long values wrap correctly. Keeping the add variable icon visible

    .compact &,
    .no-label & {
      padding-top: 0px;
      padding-left: 20px;
    }

    &.json {
      font-family: 'atomic___RobotoMono', monospace;
      white-space: pre;
      min-height: 160px;
    }

    .invalid & {
      color: ${({theme}) => theme.colors.red10};
    }

    ${variableStyle}
    .variable {
      cursor: pointer;
    }
  }
  .script-editor {
    padding-left: 0;
    margin-top: 10px;
  }
`

export const IconWrap = styled.div<{hasValue?: boolean}>`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  margin-right: -12px;
  flex-shrink: 0;
  svg {
    max-width: 16px;
    max-height: 16px;
    width: 100%;
  }
  .compact & {
    height: 20px;
    width: 20px;
    margin-left: 20px;
  }
  ${({hasValue, theme}) =>
    !hasValue
      ? css`
          color: ${theme.colors.grey10};
        `
      : null}
`

export const EditorWrap = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  align-content: center;
`

export const TextEditorWrapper = styled.div<{
  readOnly?: boolean
  monacoEditor?: boolean
}>`
  border-radius: ${({theme}) => theme.border.radius};
  padding: 8px 0;
  color: ${({theme}) => theme.colors.grey12};
  display: flex;
  gap: 12px;
  min-height: 50px;
  width: 100%;
  overflow: hidden;
  &.compact {
    min-height: 20px;
  }

  ${({readOnly, theme}) =>
    readOnly
      ? css`
          background: ${theme.white};
          border: solid 1px ${theme.colors.grey8};
        `
      : inputHoverColors}

  /* monaco is its own beast that we can't internally style well
   so don't event try */
  ${({monacoEditor, theme, readOnly}) =>
    monacoEditor && !readOnly
      ? // this isn't really hovering, its just making the hover match the background color
        // as I don't know how to disable a hover otherwise
        css`
          &:hover {
            background-color: ${theme.colors.grey3};
          }
        `
      : null}
`

// insert tribute styles globally, since it's not rendered by react
export const TributeStyle = createGlobalStyle`
.tribute-container {
  position: absolute;
  padding: 10px 0;
  background: white;
  top: 0;
  left: 0;
  border-radius: 5px;
  height: auto;
  max-height: 300px;
  width: 200px;
  overflow: auto;
  display: block;
  z-index: 999999;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    background: white;
    li {
      padding: 10px 20px;
      line-height: 20px;
      cursor: pointer;
      &.highlight {
        background: rgba(0,0,0,0.05);
      }
      &.no-match {
        cursor: default;
      }
    }
  }
  .menu-highlighted {
    font-weight: ${({theme}) => theme.fontWeights.bold};
  }
}
`
